import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ZoneBlacklistFormType } from './zone-blacklist-form-type';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { YesNoGroupButtonComponent } from 'src/app/base/shared/yes-no-group-button/yes-no-group-button.component';
import { MapBoxMapComponent, MapBoxMode } from 'src/app/base/shared/map-box-map/map-box-map.component';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-zone-details-blacklist',
  templateUrl: './zone-details-blacklist.component.html',
  styleUrls: ['./zone-details-blacklist.component.scss'],
  standalone: true,
  imports: [
    TranslateModule,
    ReactiveFormsModule,
    YesNoGroupButtonComponent,
    MapBoxMapComponent,
    NgIf
  ]
})

export class ZoneDetailsBlacklistComponent implements OnInit, OnChanges {

  @Input() useBlacklistArea: boolean;
  @Input() blacklistArea: string;
  @Output() dataChange = new EventEmitter<{ useBlacklistArea: boolean, blacklistArea: string }>();

  public blacklistForm: FormGroup<ZoneBlacklistFormType>;
  public hasGpsAreaChanged = false;

  public get gpsArea(): string {
    return this.blacklistForm.getRawValue().blacklistGPSArea ? this.blacklistForm.getRawValue().blacklistGPSArea : '';
  }

  public set gpsArea(value: string) {
    this.blacklistForm.controls.blacklistGPSArea.setValue(value);
    const origGpsArea = this.blacklistForm.controls.blacklistGPSArea.value ? this.blacklistForm.controls.blacklistGPSArea.value : '';
    this.hasGpsAreaChanged = origGpsArea.localeCompare(value) !== 0;
  }

  MapBoxMode = MapBoxMode;

  constructor(
    private fb: FormBuilder,
  ) { }

  ngOnInit() {
    this.createForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['useBlacklistArea']) {
      this.blacklistForm?.controls?.useBlacklistArea?.setValue(changes['useBlacklistArea'].currentValue);
    }
    if (changes['blacklistArea']) {
      this.blacklistForm?.controls?.blacklistGPSArea?.setValue(changes['blacklistArea'].currentValue);
    }
  }


  private createForm(): void {
    this.blacklistForm = this.fb.group<ZoneBlacklistFormType>({
      useBlacklistArea: this.fb.control<boolean>(this.useBlacklistArea),
      blacklistGPSArea: this.fb.control<string>(this.blacklistArea)
    });

    this.blacklistForm.valueChanges.subscribe((value) => {
      this.dataChange.emit({ useBlacklistArea: this.blacklistForm.controls.useBlacklistArea.value, blacklistArea: this.blacklistForm.controls.blacklistGPSArea.value });
    });
  }
}
